import posthog from "posthog-js";
import {hasAnalyticsConsent} from "@/lib/consentCookie";

const POSTHOG_DISABLED =
    process.env.NODE_ENV === "development" ||
    process.env.NEXT_PUBLIC_DISABLE_POSTHOG === "true";

function canUsePostHog(): boolean {
    if (typeof window === "undefined") return false;
    if (!process.env.NEXT_PUBLIC_POSTHOG_KEY || POSTHOG_DISABLED) return false;
    if (!hasAnalyticsConsent()) return false;
    if (posthog.has_opted_out_capturing?.()) return false;
    return true;
}

/**
 * Identify the signed-in user in PostHog and sync Braiv UI locale.
 * Safe to call repeatedly; no-ops without analytics consent.
 */
export function identifyPostHogUser(
    uid: string,
    properties?: Record<string, string | number | boolean | null | undefined>
): void {
    if (!canUsePostHog() || !uid) return;
    try {
        posthog.identify(uid, properties);
    } catch (error) {
        console.warn("PostHog identify failed", error);
    }
}

export function setPostHogPersonProperties(
    properties: Record<string, string | number | boolean | null | undefined>
): void {
    if (!canUsePostHog()) return;
    try {
        posthog.setPersonProperties(properties);
    } catch (error) {
        console.warn("PostHog setPersonProperties failed", error);
    }
}

export function resetPostHogUser(): void {
    if (typeof window === "undefined") return;
    if (!process.env.NEXT_PUBLIC_POSTHOG_KEY || POSTHOG_DISABLED) return;
    try {
        posthog.reset();
    } catch (error) {
        console.warn("PostHog reset failed", error);
    }
}

export function isPostHogCaptureEnabled(): boolean {
    return canUsePostHog();
}
